export const PREFS = {
    tab: 'trip-tab-preferences',
    intro: 'prefs-intro',
    startButton: 'prefs-start-button',
    editButton: 'prefs-edit-button',
    submittedBanner: 'prefs-submitted-banner',
    // Form
    form: 'prefs-form',
    progress: 'prefs-progress',
    backButton: 'prefs-back-button',
    nextButton: 'prefs-next-button',
    submitButton: 'prefs-submit-button',
    // Step 1
    accommodationStyle: 'prefs-accommodation-style',
    accommodationPriorities: 'prefs-accommodation-priorities',
    accommodationBudgetMin: 'prefs-accommodation-budget-min',
    accommodationBudgetMax: 'prefs-accommodation-budget-max',
    // Step 2
    foodPriorities: 'prefs-food-priorities',
    foodDietary: 'prefs-food-dietary',
    foodBudgetMin: 'prefs-food-budget-min',
    foodBudgetMax: 'prefs-food-budget-max',
    // Step 3
    pace: 'prefs-pace',
    wake: 'prefs-wake',
    walking: 'prefs-walking',
    // Step 4
    interestRow: 'prefs-interest-row',
    interestRating: 'prefs-interest-rating',
};

export const GROUP_PROFILE = {
    tab: 'trip-tab-group-profile',
    container: 'group-profile-container',
    summary: 'group-profile-summary',
    alignmentItem: 'group-profile-alignment-item',
    conflictItem: 'group-profile-conflict-item',
    waiting: 'group-profile-waiting',
    refreshButton: 'group-profile-refresh-button',
};
